import React from 'react';
import styled from 'styled-components';

const handleColorType = (module, theme) => {
	switch (module) {
		case 'storage':
			return theme.storage;
		case 'account':
			return theme.account;
		case 'billing':
			return theme.billing;
		case 'support':
			return theme.support;
		case 'colocation':
			return theme.colocation;
		default:
			return theme.main;
	}
};

const DailySVG = styled.svg`
	width: 10px !important;
	height: 15px !important;

	.daily,
	.daily-1,
	.daily-2,
	.daily-3 {
		fill: #a2a9ad;
	}
`;

export const ClipSelector = props => {
	const { id, theme, module, position, className } = props;
	const rotate = position === 'left' ? 'rotate(90)' : 'rotate(270)';
	return (
		<DailySVG id={id} module={module} width='8.582' height='8.582' viewBox='0 0 12.24 20.1'>
			<defs>
				<linearGradient
					id={`${id}-swipe-gradient`}
					x1='0.5'
					y1='1'
					x2='0.5'
					y2='-2'
					gradientTransform={rotate}
				>
					<stop offset='0' stop-color='white'>
						<animate
							id={`${id}trans1`}
							dur='0.7s'
							attributeName='offset'
							fill='freeze'
							from='0'
							to='1'
							restart='always'
							begin='indefinite'
						/>
					</stop>
					<stop offset='0' stop-color={handleColorType(module, theme)}>
						<animate
							id={`${id}trans1`}
							dur='0.7s'
							attributeName='offset'
							fill='freeze'
							from='0'
							to='1'
							restart='always'
							begin='indefinite'
						/>
					</stop>
				</linearGradient>
			</defs>
			<path
				id='Clip'
				d='M51.33,55.35A4.37,4.37,0,0,1,47,51V41.37a2.61,2.61,0,0,1,.77-1.85,2.68,2.68,0,0,1,3.71,0,2.61,2.61,0,0,1,.77,1.86v8.74H50.46V41.37a.87.87,0,0,0-.26-.62.89.89,0,0,0-1.23,0,.87.87,0,0,0-.26.62V51a2.65,2.65,0,0,0,.77,1.86,2.69,2.69,0,0,0,3.71,0A2.65,2.65,0,0,0,54,51V41.37a4.37,4.37,0,0,0-8.74,0v6.21H43.47V41.37a6.12,6.12,0,1,1,12.23,0V51a4.37,4.37,0,0,1-4.37,4.37Z'
				class={className}
				transform='translate(-43.47 -35.25)'
			/>
		</DailySVG>
	);
};
